import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Subscribe to /api/events?conv=<id>. On `proposals_changed` events,
 * invalidate every panneau query so the UI refetches state. Heartbeat
 * `ping` events are ignored.
 */
export function useEventStream(conv: string | null) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!conv) return;
    const url = `/api/events?conv=${encodeURIComponent(conv)}`;
    const es = new EventSource(url);

    const refetchAll = () => {
      qc.invalidateQueries({ queryKey: ["panneau"] });
      qc.invalidateQueries({ queryKey: ["panneaux"] });
    };

    es.addEventListener("proposals_changed", refetchAll);
    // The endpoint also emits a `ready` event on connect; we don't act
    // on it but listening keeps logging quieter.
    es.addEventListener("ready", () => {});
    es.addEventListener("ping", () => {});
    es.onerror = () => {
      // EventSource auto-reconnects; nothing to do.
    };
    return () => es.close();
  }, [conv, qc]);
}
